import { defineComponent, createElementBlock, openBlock, normalizeClass } from 'vue';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "LoadingSkeleton",
  props: {
    type: { default: "default" }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(["loading-skeleton", `is-type-${_ctx.type}`])
      }, null, 2);
    };
  }
});

export { _sfc_main as default };
